module.exports = __webpack_public_path__ + "static/media/video-real-estate-1.0e111f57.mp4";